<template>
  <div class="h-full">
    <!-- Renkli Varyantlı Ürün -->
    <FrontendProductCardWithColors v-if="product.colors?.length > 0" :product="product" class="h-full" v-bind="$attrs"
      @add-to-cart="$emit('add-to-cart', $event)" @toggle-favorite="handleToggleFavorite" />

    <!-- Renksiz Varyantlı Ürün -->
    <!-- <FrontendProductCardWithVariant
      v-else-if="product.best_offer"
      :product="product"
      class="h-full"
      v-bind="$attrs"
      @add-to-cart="$emit('add-to-cart', $event)"
      @toggle-favorite="handleToggleFavorite"
    /> -->

    <!-- Basit Ürün -->
    <FrontendProductCard v-else :product="product" class="h-full" v-bind="$attrs"
      @add-to-cart="$emit('add-to-cart', $event)" @toggle-favorite="handleToggleFavorite" />
  </div>
</template>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    required: true
  }
})

defineEmits(['add-to-cart', 'toggle-favorite'])

const { toggleFavorite } = useFavorites()

// Favori durumunu değiştir
const handleToggleFavorite = async () => {

  if (props.product?.id) {
    await toggleFavorite(props.product)
  }
}
</script>
